var React = require('react');

function M2HeartCircleComponent (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 18.25C10.5714 17.2582 9.20913 16.1399 8.03308 14.8556C6.9488 13.6716 6 12.2648 6 10.8876C6 9.05766 7.48227 7.25 9.41958 7.25C10.1427 7.25 10.7819 7.47344 11.3333 7.85365C11.5244 7.98538 11.7212 8.21712 11.8887 8.41426C11.9275 8.45997 11.9648 8.50381 12 8.54412C12.0352 8.50381 12.0725 8.45997 12.1113 8.41427C12.2788 8.21712 12.4756 7.98538 12.6667 7.85365C13.2181 7.47344 13.8573 7.25 14.5804 7.25C16.5177 7.25 18 9.05766 18 10.8876C18 12.2648 17.0512 13.6716 15.9669 14.8556C14.7909 16.1399 13.4286 17.2582 12 18.25Z"}));
}

M2HeartCircleComponent.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = M2HeartCircleComponent;

M2HeartCircleComponent.default = M2HeartCircleComponent;
